import React from 'react';
import {twMerge} from 'tailwind-merge';

export const ColorPalettePreview = ({
  colors,
  borderClassName,
  className,
  'data-test': dataTest,
}: {
  colors: readonly string[];
  borderClassName?: string;
  className?: string;
  'data-test'?: string;
}) => {
  return (
    <div
      data-test={dataTest}
      className={twMerge(
        'night-aware flex w-full gap-x-2 rounded-2xl p-8 outline outline-1 outline-moon-250 dark:outline-moon-750',
        borderClassName
      )}>
      {colors.map(color => (
        <div
          key={color}
          style={{backgroundColor: color}}
          className={twMerge(
            'h-12 w-full first:rounded-l-lg last:rounded-r-lg',
            className
          )}
        />
      ))}
    </div>
  );
};
